export const GET_CATALOGUE = "GET_CATALOGUE";
export const SET_CATALOGUE = "SET_CATALOGUE";
export const CLEAR_CATALOGUE = "CLEAR_CATALOGUE";
